import "./validationerror.css";
import React from "react";

export default function ValidationError({ error }) {
  if (error) {
    const messages = Array.isArray(error) ? error : [error];
    return (
      <div className="validation-error">
        {messages.map((er) => {
          return <p>{er}</p>;
        })}
      </div>
    );
  } else {
    return null;
  }
}
